module.exports = __webpack_public_path__ + "img/ab4d36d.png";